import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/shared/services/base.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseDefault } from 'src/app/shared/data/response-default.interface';
import { CreateReason, IAddCompaniesToReason, IFilterReasons, IReason } from '../data/reason';

@Injectable({
  providedIn: 'root'
})
export class ManagerReasonService extends BaseService {
  private readonly apiUrl = `${this.urlService}${environment.microservices.company}ManagerReason`;
  //private readonly apiUrl = `https://localhost:5009/company/ManagerReason`

  constructor(
    private readonly http: HttpClient,
    protected readonly toast: ToastService
  ) {
    super(toast);
  }

  getAttendanceReports(filter: IFilterReasons): Observable<ResponseDefault<IReason[]>> {
    let params = new HttpParams().appendAll({
      pageNumber: filter.pageNumber.toString(),
      pageSize: filter.pageSize.toString()
    });

    if (filter.searchText) {
      params = params.append('searchText', filter.searchText);
    }

    return this.http.get<ResponseDefault<IReason[]>>(`${this.apiUrl}/List`, { params });
  }

  createReason(reason: CreateReason): Observable<ResponseDefault<IReason>> {
    return this.http.post<ResponseDefault<IReason>>(`${this.apiUrl}/Create`, reason);
  }

  getReasonById(id: string): Observable<ResponseDefault<IReason>> {
    return this.http.get<ResponseDefault<IReason>>(`${this.apiUrl}/Reason/${id}`);
  }

  updateReason(id: string, reason: IReason): Observable<ResponseDefault<IReason>> {
    return this.http.put<ResponseDefault<IReason>>(`${this.apiUrl}/Reason/${id}`, reason);
  }

  listAllReasons(partnerId?: string): Observable<ResponseDefault<IReason[]>> {
    let params = new HttpParams();

    if (partnerId) {
      params = params.append('partnerId', partnerId);
    }
    return this.http.get<ResponseDefault<IReason[]>>(`${this.apiUrl}/ListAll`, { params });
  }

  getCompanyReasons(companyId: string): Observable<ResponseDefault<IReason[]>> {
    return this.http.get<ResponseDefault<IReason[]>>(`${this.apiUrl}/GetCompanyReasons/${companyId}`);
  }

  addReasonToCompany(body: { companyId: string; reasonIds: string[] }): Observable<ResponseDefault<IReason>> {
    return this.http.post<ResponseDefault<IReason>>(`${this.apiUrl}/AddReasonToCompany`, body);
  }

  getReasonCompanies(reasonId: string): Observable<ResponseDefault<string[]>> {
    return this.http.get<ResponseDefault<string[]>>(`${this.apiUrl}/GetReasonCompanies/${reasonId}`);
  }

  addCompaniesToReason(body: IAddCompaniesToReason): Observable<ResponseDefault<boolean>> {
    return this.http.post<ResponseDefault<boolean>>(`${this.apiUrl}/AddCompaniesToReason`, body);
  }

  addReasonToQueue(body: {
    queueId: string;
    reasonIds: string[];
    exceptionReasonIds?: string[];
  }): Observable<ResponseDefault<IReason>> {
    return this.http.post<ResponseDefault<IReason>>(`${this.apiUrl}/AddReasonToQueue`, body);
  }

  getQueueReasons(queueId: string): Observable<ResponseDefault<IReason[]>> {
    return this.http.get<ResponseDefault<IReason[]>>(`${this.apiUrl}/GetQueueReasons/${queueId}`);
  }
}
